import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

// network-only in the consumer: the Information tab embeds the node edit form,
// which must always start from fresh attribute values (like EditNodeModal).
export const InstalledBaseNodeInformation = gql`
  query InstalledBaseNodeInformation ($id: ID!) {
    installedBaseNode (id: $id) {
      id
      insert
      update
      childrenNodeCount
      assetCount
      fileList {
        total
      }
      image {
        id
        file {
          id
          thumbnailLink(crop: fit, w: 200, h: 200)
        }
      }
      typeDefinitionAttributeList {
        total
        typeDefinitionAttributes {
          ...TypeDefinitionAttributeFields
        }
      }
    }
  }
  ${TypeDefinitionAttributeFields}
`;
